const KEYS = {
    TULIP_LOADOUT: 'tuliploadout',
    TULIP_LOADOUT_PRIMARY: 'tuliploadout/primary',
    MARKETPLACE_AGREEMENT: 'marketplace/agreement',
};

export default KEYS;